module.exports = __webpack_public_path__ + "img/horizontal_7_7_0.3f368f23.png";